import { css } from '@emotion/react'
import { nanoid } from 'nanoid'
import React, { type ComponentProps, type MouseEventHandler, useContext, useMemo } from 'react'

import { Icon } from '@/component/atoms/Icon'
import { RadioGroupContext } from '@/component/molecules/Radio/context.tsx'
import type { DefaultProps } from '@/types'

import { S } from './SubTab.style.ts'

type Props = {
  value?: string
  iconName?: ComponentProps<typeof Icon>['name']
  disabled?: boolean
  rounded?: boolean
  onClick?: MouseEventHandler<HTMLLabelElement>
} & DefaultProps

const TabItem = ({
  value,
  iconName,
  disabled,
  children,
  className,
  style,
  rounded = false,
  onClick,
}: Props) => {
  const context = useContext(RadioGroupContext)!
  const id = useMemo(() => nanoid(), [])
  const controlledParams = (context.value && { checked: context.value === value }) || undefined

  return (
    <S.TabItem className={className} style={style}>
      <input
        id={id}
        type="radio"
        value={value}
        disabled={disabled}
        onChange={context.onChange}
        {...controlledParams}
      />
      <label
        htmlFor={id}
        onClick={disabled ? undefined : onClick}
        css={
          rounded &&
          css`
            border-radius: var(--Radius-Circle) !important;
          `
        }
      >
        {children}
        {iconName && <Icon name={iconName} size={20} />}
      </label>
    </S.TabItem>
  )
}

export default TabItem
